import type { LanguageCodeEnum } from '@/graphql/saleor/api';
import { getTranslatedMessage } from '@/lib/intl';

export const translateStrapMaterial = async (
  languageCode: LanguageCodeEnum,
  strapMaterial?: string | null,
) => {
  if (!strapMaterial) {
    return '';
  }

  return await getTranslatedMessage(
    languageCode,
    `algolia.strap.material.${strapMaterial}`,
    strapMaterial,
  );
};
